const COMPLETED_AUTHENTICATION_BY_VALUES = new Set(['mem', 'mem_id', 'org', 'org_main']);

export const isAuthenticationComplete = (authenticationBy?: string | null): boolean => {
  const normalized = String(authenticationBy ?? '').trim().toLowerCase();
  return COMPLETED_AUTHENTICATION_BY_VALUES.has(normalized);
};

